import React, { useState, useEffect } from 'react'
import {
  DirectionalHint,
  IconButton,
  SearchBox,
  Stack,
  TooltipHost,
} from 'office-ui-fabric-react'
import { debounce } from 'lodash'

interface Props {
  onSearch: (textSearch: string) => void
}

export function Filter({ onSearch }: Props) {
  const [textSearchShown, setTextSearchShown] = useState<boolean>(false)
  const [textSearch, setTextSearch] = useState<string>('')
  useEffect(() => {
    const eventListener = (ev: Event) => {
      if (!ev || !ev.target) {
        return
      }
      if (textSearch.length) {
        return
      }
      if (
        !(ev.target as HTMLElement).className
          .toString()
          .match(/ms-SearchBox-field/)
      ) {
        setTextSearchShown(false)
      }
    }
    document.addEventListener('mousedown', eventListener)
    return () => document.removeEventListener('mousedown', eventListener)
  })
  return (
    <Stack
      horizontal
      horizontalAlign="start"
      styles={{
        root: {
          padding: 5,
          background: textSearchShown
            ? 'var(--color-filter-background)'
            : 'var(--color-white)',
          boxShadow: 'var(--color-filter-shadow)',
          position: 'absolute',
          transition: 'all 0.3s',
          width: textSearchShown ? 210 : 'auto',
          top: 60,
          right: 26,
        },
      }}
    >
      {textSearchShown ? (
        <SearchBox
          autoFocus
          placeholder="Filter"
          iconProps={{ iconName: 'Filter' }}
          value={textSearch}
          spellCheck={false}
          disableAnimation={true}
          autoComplete={'off'}
          styles={{ root: { width: '100%' } }}
          onChange={debounce((value?: string) => {
            const newTextSearch = value || ''
            setTextSearch(newTextSearch)
            onSearch(newTextSearch)
          }, 1e3)}
          onClear={() => setTextSearchShown(false)}
        />
      ) : (
        <TooltipHost
          className={'table-tooltip'}
          content="Filter table"
          tooltipProps={{
            delay: 0,
            directionalHint: DirectionalHint.rightCenter,
          }}
        >
          <IconButton
            iconProps={{ iconName: 'filter' }}
            onClick={() => setTextSearchShown(true)}
          />
        </TooltipHost>
      )}
    </Stack>
  )
}
